// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__1sk0-","content":"layout_content__kMvW9"};